import React, { useEffect, useState } from "react";
import {useLocation, useNavigate} from "react-router-dom";
import '../css/News.css';
import axios from "axios";
import StockChart from "../components/StockChart";
import StockDate from "./StockDate";
import { handleLogout } from "../utils/logout";
import { splitSummary } from "../utils/splitSummary";
import { handleSearch } from "../utils/search";
import { getDaysDiff } from "../utils/dateUtils";
import { fetchSessionUser } from "../utils/userInfo";
import { fetchNewsData } from "../utils/newsError";
import Footer from "./Footer";
import Header from "./Header";
import AdLeft from "./AdLeft";
import AdRight from "./AdRight";

function NewsPrediction() {
    const navigate = useNavigate();
    const location = useLocation();
    const [profileBox, setProfileBox] = useState(false); // 프로필 박스 토글
    const [urlInput, setUrlInput] = useState("");
    const [newsData, setNewsData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [userInfo, setUserInfo] = useState(null);


    const url = location.state?.url;
    let id = location.state?.id;

    useEffect(() => {
        const background = document.querySelector('.News-img');
        const summaries = document.querySelectorAll('.summary-paragraph');

        if (background && summaries.length > 0) {
            let totalHeight = 0;
            summaries.forEach((el) => {
                totalHeight += el.offsetHeight;
            });

            const newHeight = 2500 + totalHeight + 200;
            background.style.height = `${newHeight}px`;
        }
    }, [newsData]); // 뉴스 데이터가 바뀔 때마다 재계산

    useEffect(() => {
        fetchSessionUser(setUserInfo, (err) => {
            // 로그인 실패 시 원하는 동작 수행
            // 예: navigate("/")
        });
    }, []);

    useEffect(() => {
        fetchNewsData(url, id, setNewsData, setLoading);
    }, [url, id]);

    if (!newsData) return <p>뉴스 정보를 가져오지 못했습니다.</p>;

    const profileToggleBox = () => {
        setProfileBox(!profileBox);
    };

    const isLogin = !!userInfo?.username;

    const classifyScore = (score) => {
        if (score >= 0.7) {
            return "상";
        } else if (score >= 0.5) {
            return "중";
        } else {
            return "하";
        }
    };
    const keywordList = Array.isArray(newsData?.keyword) ? (
        newsData.keyword.map((item) => (
            <li className="keyword-paragraph" key={item.word}>
                {item.word} - {classifyScore(item.score)}
            </li>
        ))
    ) : (
        <li>키워드 없음</li>
    );

    const sentimentList = newsData?.sentiment ? (
        <li className="keyword-paragraph">{newsData.sentiment}</li>
    ) : (
        <li>감성 정보 없음</li>
    );

    const createdAt = new Date(newsData.createdAt);
    const now = new Date();
    const diffDays = parseInt((now - createdAt)  / (1000 * 60 * 60 * 24));
    const diffHours = parseInt((((now - createdAt)  / (1000 * 60 * 60 * 24)) - diffDays) * 24);
    const today = new Date();

    const daysDiff = getDaysDiff(new Date(), newsData?.date);

    const newsDiffDays = newsData ? getDaysDiff(today, newsData.time) : null;

    return (
        <div className="News">
            <Header />
            {/* 좌측 광고 */}
            <div className="AdLeft-container">
                <AdLeft />
            </div>
            {/* 우측 광고 */}
            <div className="AdRight-container">
                <AdRight />
            </div>
            <div className="News-img"></div>
            <header className="News-header">
                <div className="News-home-container">
                    <button className="News-home-button" type="button" onClick={() => navigate("/")}>
                        <img
                            className="News-home-button-img"
                            src="/snake.png"
                            alt="타이틀 이미지"
                        />
                    </button>
                </div>

                <div className="News-Search">
                    <input
                        id="News-search-input"
                        placeholder="뉴스 URL을 입력하세요."
                        value={urlInput}
                        onChange={(e) => setUrlInput(e.target.value)}
                        onFocus={(e) => e.target.select()}
                        onKeyDown={(e) => {
                            if (e.key === "Enter") {
                                handleSearch(urlInput, id, navigate); // ✅ 엔터로 검색 실행
                            }
                        }}
                    />
                    <img
                        className="News-search-img"
                        src="/icon.png"
                        alt="돋보기"
                        onClick={() => handleSearch(urlInput, id, navigate)}
                    />
                </div>

                <div className="News-container">
                    <div className="News-container-news">
                        <a href={newsData.url} target="_blank" rel="noopener noreferrer" className="news-link">
                            <div className="News-news-img">
                                {newsData.thumbnail_url ? (
                                    <img className="News-newsimg" src={newsData.thumbnail_url} alt="썸네일"/>
                                ) : (
                                    <img src="/default-thumbnail.png" alt="기본 썸네일"/>
                                )}
                            </div>
                        </a>
                        <div className="News-news">
                            <div className="News-news-title">
                                <p>{newsData.title}</p>
                            </div>
                            <div className="News-news-detail">
                                <p>{newsData.content}</p>
                            </div>
                            <div className="News-news-date">
                                <p>{newsData.time}</p>
                            </div>
                        </div>


                    </div>

                    <div className="News-container-summation">
                        <div className="News-summation-detail">
                            <p className="summary-title">해당 뉴스의 요약</p>
                            {newsData.summary && splitSummary(newsData.summary).map((sentence, index) => (
                                <p className="summary-paragraph" key={index}>{sentence}</p>
                            ))}
                            <p className="summary-title">해당 뉴스의 키워드<br />
                                <small style={{ color: '#888' }}>유사도 상 (0.9% ~ 0.7%) 중 (0.7% ~ 0.5%) 하 (0.5% ~)</small></p>
                            <il>{keywordList}</il>
                            <p className="summary-title">해당 뉴스의 관련된 회사</p>
                            <p className="keyword-paragraph">{newsData.company}</p>

                            <p className="summary-title">해당 뉴스의 감성분석<br /></p>
                            <il>{sentimentList}</il>

                            <p className="summary-title">해당 뉴스의 주가 예측<br /></p>
                            <p className="keyword-paragraph">해당 뉴스의 주가 예측으로 {newsData.prediction} (정확도 {(newsData.prob * 100).toFixed(2)}%) 할 것으로 예측하였습니다.</p>

                            <p className="summary-title">{newsData.company}의 주가<br /></p>
                            <p className="keyword-paragraph"><StockDate companyName={newsData.company} /></p>

                            <p className="summary-title">며칠 전 뉴스인가요?<br /></p>
                            <p className="keyword-paragraph">{newsDiffDays}일 전 기사입니다. </p>

                            <p className="summary-title">검색 후 얼마나 지났나요?<br /></p>
                            <p className="keyword-paragraph">{diffDays}일 {diffHours==0 ? ("") : (diffHours + "시간")} 전에 검색했던 기록입니다. </p>
                        </div>
                        <div className="News-summation-chart">
                            <StockChart companyName={newsData.company} />
                        </div>
                    </div>
                </div>

            </header>

        </div>
    );
}

export default NewsPrediction;